
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_3bgfn_7z52j_3"
};
  